<template>
  <v-app>
    <v-container fluid class="bg-cover" style="padding: 0; margin: 0;">
      <router-view :key="$route.fullPath" />
      
    </v-container>
  </v-app>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      showTerms: false
    };
  }
};
</script>
<style lang="scss">
html {
  scroll-behavior: smooth;
}
html,
body {
  font-family: "Raleway";
  padding: 0;
  margin: 0;
}
#app {
  font-family: "Raleway", "Helvetica Neue", Helvetica, Arial, "Microsoft YaHei", "Microsoft YaHei Light", "MS Mincho", "BrowalliaUPC", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.bg-cover {
  // background-image: url(assets/images/bg2.png);
  background-size: cover;
  background-position: center center;
}
.en {
  font-size: 13px;
}
.en-topic {
  font-size: 16px;
}
.cn {
  font-size: 13px;
}
.cn-topic {
  font-size: 16px;
}
.th {
  font-family: "Browallia New", sans-serif;
  font-size: 20px;
  line-height: 27px;
}
.th-topic {
  font-size: 22px;
}
.th-cover {
  font-size: 26px;
}
.th-resort-name {
  font-size: 40px;
  line-height: 50px;
}


</style>
